<div class="ownerdb_wrapper">
    <div class="ownerdb_navigation" *ngIf="ownerDbScreen != 'summary' ">
        
            <div class="nav-item col-sm-2 col-md-2 btn">
                <p class="ownerdb_nav_item" (click)="changeSection('summary')" [ngClass]="ownerDbScreen == 'summary' ? 'selected_ownerbd_nav_item' : ''">Summary</p>
            </div>
            <div class="nav-item col-sm-2 col-md-2 btn">
                <p class="ownerdb_nav_item" (click)="changeSection('onboarding')" [ngClass]="ownerDbScreen == 'onboarding' ? 'selected_ownerbd_nav_item' : ''">Onboarding</p>
            </div>
            <div class="nav-item col-sm-2 col-md-2 btn">
                <p class="ownerdb_nav_item" (click)="changeSection('tenants')" [ngClass]="ownerDbScreen == 'tenants' ? 'selected_ownerbd_nav_item' : ''">Tenants</p>
            </div>
            <div class="nav-item col-sm-2 col-md-2 btn">
                <p class="ownerdb_nav_item" (click)="changeSection('audits')" [ngClass]="ownerDbScreen == 'audits' ? 'selected_ownerbd_nav_item' : ''">Audits</p>
            </div>
            <div class="nav-item col-sm-2 col-md-2 btn">
                <p class="ownerdb_nav_item" (click)="changeSection('rentmeter')" [ngClass]="ownerDbScreen == 'rentmeter' ? 'selected_ownerbd_nav_item' : ''">Rent-O-Meter</p>
            </div>
            <div class="nav-item col-sm-2 col-md-2 btn">
                <p class="ownerdb_nav_item" (click)="changeSection('srequests')" [ngClass]="ownerDbScreen == 'srequests' ? 'selected_ownerbd_nav_item' : ''">Service Requests</p>
            </div>
        
    </div>
    <!-- Owner Dashboard Summary Screen -->
    <div *ngIf="ownerDbScreen == 'summary'">
        <h1 class="greeting" style="margin-top: 2%" data-aos="fade-down"  data-aos-duration="1000">Hi {{user.name}}! Let's see how Your Own Property is doing.</h1>
        <div class="row owner_data justify-content-between">
            <div class="col-6 col-md-3 owner_details" style="margin-bottom: 5%;">
                <div style="display: flex; justify-content: center;">
                    <img *ngIf="user.id != 1412" src="../../assets/images/profile.png" class="owner_img"  >
                    <img *ngIf="user.id == 1412" src="{{ownerImgMedUrl}}" class="owner_img"  >
                </div>
                <p class="owner_name" >{{user.name}}</p>
                <p class="owner_name" >+91 {{user.phone}}</p>
                <p class="owner_name" >{{user.email}}</p>
            </div>
            <div class="col-12 col-md-3 small_owner_details" style="margin-bottom: 5%;">
                <div class="d-flex justify-content-between align-items-center">
                    <img src="../../assets/images/profile.png" class="owner_img"  >
                    <div style="display: inline-block; text-align: center;">
                        <div style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
                            <p class="owner_name" >{{user.name}}</p>
                            <p class="owner_name" >+91 {{user.phone}}</p>
                            <p class="owner_name" >{{user.email}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-8" *ngIf="ownerProperties == 1" >
                <div class="prop_ytd_income" data-aos="fade-up" data-aos-duration="1000">
                    <p class="ytd_data" >{{properties}}</p>
                    <br>
                    <p class="ytd_data" >Total Earnings: {{YTDearning}}</p>
                </div>
                <div *ngFor="let prop of ownerPropData" data-aos="fade-right" data-aos-duration="1000" >
                    <div class="prop_data_wrapper" (click)="changeProperty(prop.id )">
                        <p class="property_name" style="width: 100%;">{{prop.name}} <span class="property_status">{{prop.status == "blocked" ? "( Blocked )" : "" }}</span></p>
                        <div class="row prop_data_row">
                            <div class="col-12 col-sm-4 col-md-6 col-lg-4 small_center">
                                <p class="property_data">Total Income : <span style="font-weight: 500;">{{prop.ytdIncome}}</span></p>
                                <p class="property_data">Spends (Services) : <span style="font-weight: 500;">{{prop.srSpent}} </span></p>
                                <p class="property_data">Service Requests : <span style="font-weight: 500;">{{prop.srCount}}</span></p>
                            </div>
                            <div class="col-12 col-sm-4 col-md-6 col-lg-4 center">
                                <p class="property_data ">Audits Conducted : <span style="font-weight: 500;">{{prop.auditCount}}</span></p>
                                <p class="property_data">Total rooms : <span style="font-weight: 500;">{{prop.totalrooms}}</span></p>
                                <p class="property_data">Site Visits : <span style="font-weight: 500;">{{prop.totalSiteVisits}}</span></p>
                            </div>
                            <div class="col-12 col-sm-4 col-md-12 col-lg-4 end">
                                <p class="property_data_1">Tenants <span style="font-weight: 500;">{{prop.totalActiveTenants}} / {{prop.totalTenants}}</span></p>
                                <p class="property_data_1">Beds <span style="font-weight: 500;">{{prop.totalActiveTenants}} / {{prop.totalTenants}}</span></p>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-9" *ngIf="ownerProperties == 0" >
                <p class="property_name" style="width: 100%;">You dont have any properties registered with us. <br> </p>
                <p class="property_name" style="width: 100%;">Please register your property with us for a hassle free property maintenace experience.</p>
            </div>
        </div>
    </div>
    <!-- Owner Dashboard property Onboarding -->
    <div *ngIf="ownerDbScreen == 'onboarding' && onboardingLoading == 0" style="height: 300px; display: flex; justify-content: center; align-items: center;">
        <img src="../../assets/images/loading.gif" class="faLoader" width="50" height="50" />
    </div>
    <div *ngIf="ownerDbScreen == 'onboarding' && onboardingLoading == 1">
        <select id="selectedProp" class="selected_prop" [ngModel]="selectedPropId" (ngModelChange)="changeProp($event)">
            <option *ngFor="let prop of ownerPropData" [ngValue]="prop.id">{{prop.name}}</option>
        </select>
        <h1 class="greeting" >Hi {{user.name}}! Let's look at te property onboarding process</h1>
        <div class="row onboard_wrapper justify-content-between" >
            <div class="col-12 col-md-4" data-aos="fade-down" data-aos-duration="1500">
                <p [ngClass]="onboardingData.registered == 1 ? 'green' : 'red'" (click)="onboardingStepDetail(1)" class="onboarding_step"><span ><fa-icon class="fa-sm" [icon]="onboardingData.registered == 1 ? faCheckCircle : faExclamationCircle" ></fa-icon></span> Registration</p>
                <div class="onboadingLines" [ngClass]="onboardingStep == 1 ? 'vertical_line' : 'vertical_small_line'"></div>

                <p [ngClass]="ownerDocuments == 1 ? 'green' : 'red'" (click)="onboardingStepDetail(2)" class="onboarding_step"><span ><fa-icon class="fa-sm" [icon]="ownerDocuments == 1 ? faCheckCircle : faExclamationCircle" ></fa-icon></span> Documents</p>
                <div class="onboadingLines" [ngClass]="onboardingStep == 2 && ownerDocuments == 1 ? 'vertical_line_green' : onboardingStep == 2 && ownerDocuments == 0 ? 'vertical_line_red': onboardingStep != 2 && ownerDocuments == 1 ? 'vertical_small_line_green' : 'vertical_small_line_red'"></div>

                <p [ngClass]="ownerPropMaintain == 1 ? 'green' : 'red'" (click)="onboardingStepDetail(3)" class="onboarding_step"><span ><fa-icon class="fa-sm" [icon]="ownerPropMaintain == 1 ? faCheckCircle : faExclamationCircle" ></fa-icon></span> Maintenance</p>
                <div class="onboadingLines" [ngClass]="onboardingStep == 3 && ownerPropMaintain == 1 ? 'vertical_line_green' : onboardingStep == 3 && ownerPropMaintain == 0 ? 'vertical_line_red' : onboardingStep != 3 && ownerPropMaintain == 1 ? 'vertical_small_line_green' : 'vertical_small_line_red' "></div>

                <p [ngClass]="onboardingData.property_approved == 1 ? 'green' : 'red'" (click)="onboardingStepDetail(4)" class="onboarding_step"><span><fa-icon class="fa-sm" [icon]="onboardingData.property_approved == 1 ? faCheckCircle : faExclamationCircle" ></fa-icon></span> Furniture</p>
                <div class="onboadingLines" [ngClass]="(onboardingStep == 4 || onboardingStep == 5 ) && onboardingData.property_approved == 1 ? 'vertical_line_green' : (onboardingStep == 4 || onboardingStep == 5 ) && onboardingData.property_approved != 1 ? 'vertical_line_red' : (onboardingStep != 4 || onboardingStep != 5 ) && onboardingData.property_approved == 1 ? 'vertical_small_line_green' : (onboardingStep != 4 || onboardingStep != 5 ) && onboardingData.property_approved != 1 ? 'vertical_small_line_red' : ''"></div>

                <p [ngClass]="(goLiveDateCheck == 1 && onboardingData.property_approved == 1 && ownerPropMaintain == 1 && ownerDocuments == 1 && onboardingData.registered == 1) ? 'green' : 'skyblue'"  (click)="onboardingStepDetail(5)" class="onboarding_step"><span><fa-icon class="fa-sm" [icon]="(goLiveDateCheck == 1 && onboardingData.property_approved == 1 && ownerPropMaintain == 1 && ownerDocuments == 1 && onboardingData.registered == 1) ? faCheckCircle : faExclamationCircle" ></fa-icon></span> {{(goLiveDateCheck == 1 && onboardingData.property_approved == 1 && ownerPropMaintain == 1 && ownerDocuments == 1 && onboardingData.registered == 1) ? 'GO LIVE on ' + goLiveDateEn : 'GO LIVE (Pending)' }}</p>
            </div>
            <div class="col-md-6">
                <div class="onboard_registration_active"  data-aos="fade-left" data-aos-duration="1500" *ngIf="onboardingStep == 1 ">
                    <p><span style="color: #4BB543"><fa-icon class="fa-lg" [icon]="faCheckSquare"></fa-icon></span>     Your property is successfully registered!</p>
                </div>
                <div class="onboard_doc_active" data-aos="fade-left" data-aos-duration="1500" *ngIf="onboardingStep == 2" [ngStyle]="{'background-color': ownerDocuments == 1 ? '#EBF7EE' : '#FCEDEA' }">
                    <h4><span [ngClass]="ownerDocuments == 1 ? 'green' : 'red'" ><fa-icon class="fa-lg" [icon]="ownerDocuments == 1 ? faCheckCircle : faExclamationCircle"></fa-icon></span>     Documents submitted by you</h4>
                    <br>
                    <div *ngFor="let doc of ownerDocData">
                        <div class="owner_doc_wrapper" (click)="openDocs(doc.url)">
                            <p>{{doc.type == 'adhar' ? 'Adhaar' : doc.type == 'pan' ? 'PAN' : doc.type == 'policeverification' ? 'Police Verification' : doc.type == 'employment' ? 'Employment Proof' : ''}}</p>
                            <p [ngClass]="doc.status == 10 ? 'docVerified' : 'docPending'">{{doc.status == 10 ? 'Verified' : 'Pending'}}  <span><img class="openLink" src="../../assets/images/right-arrow.svg" ></span></p>
                        </div>
                    </div>
                </div>
                <div class="onboard_maintain_active" data-aos="fade-left" data-aos-duration="1500" *ngIf="onboardingStep == 3" [ngStyle]="{'background-color': ownerPropMaintain == 1 ? '#EBF7EE' : '#FCEDEA' }" >
                    <h4><span [ngClass]="ownerPropMaintain == 1 ? 'green' : 'red'" ><fa-icon class="fa-lg" [icon]="ownerPropMaintain == 1 ? faCheckCircle : faExclamationCircle"></fa-icon></span>     Maintenance</h4>
                    <br>
                    <div *ngFor="let m of ownerPropMaintainData">
                        <div class="owner_doc_wrapper">
                            <p>
                                <span>
                                    <fa-icon 
                                        [icon]="m.type == 'Keys' ? faKey : m.type == 'Plumbing' ? faFaucet : m.type == 'Furnishing' ? faCouch : m.type == 'Cleaning' ? faBroom : m.type == 'Electricity/Electrical appliances' ? faPlug : m.type == 'Carpenting' ? faTools : faCogs" 
                                        class="fa-sm" 
                                        [ngStyle]="{'color': m.status == 'Open' ? 'coral' : m.status == 'Closed' ? '#4BB543' : 'skyblue'}">
                                    </fa-icon>
                                </span>   
                                {{m.type}}
                            </p>
                            <p [ngClass]="m.status == 'Open' ? 'red' : m.status == 'Closed' ? 'green' : 'blue' ">{{m.status}} ({{m.percentage}}%)</p>
                        </div>
                        <br>
                    </div>
                </div>
                <div class="onboard_furniture_active" data-aos="fade-left" data-aos-duration="1500" *ngIf="onboardingStep == 4 " [ngStyle]="{'background-color': onboardingData.property_approved == 1 ? '#EBF7EE' : '#FCEDEA' }" >
                    <p><span [ngClass]="onboardingData.property_approved == 1 ? 'green' : 'red' "><fa-icon class="fa-lg" [icon]="onboardingData.property_approved == 1 ? faCheckCircle : faExclamationCircle"></fa-icon></span>     {{onboardingData.property_approved == 1 ? 'All the furniture is set and the property is ready to go live.' : 'Furniture is being set in the property by our team!'}}</p>
                </div>
            </div>
            
        </div>
    </div>
    <!-- Owner Dashboard Property Tenants Screen -->
    <div *ngIf="ownerDbScreen == 'tenants' && onboardingTenantLoading == true" style="height: 300px; display: flex; justify-content: center; align-items: center;" class="loaderWrapper">
        <img src="../../assets/images/loading.gif" class="faLoader" width="50" height="50" />
    </div>
    <div *ngIf="ownerDbScreen == 'tenants'  && onboardingTenantLoading == false">
        <select id="selectedProp" class="selected_prop" [ngModel]="selectedPropId" (ngModelChange)="changeProp($event)">
            <option *ngFor="let prop of ownerPropData" [ngValue]="prop.id">{{prop.name}}</option>
        </select>
        <h1 class="greeting" >Hi {{user.name}}! Let's look at the tenants in your property.</h1>
        <div *ngIf="selectedPropTenantData.length > 0">
            <div *ngFor="let ten of selectedPropTenantData " class="row justify-content-around owner_tenant_data" data-aos="fade-up" data-aos-delay="-20" data-aos-duration="500">
                <div class="col-xs-d-none col-sm-3 col-md-2" style="display: flex; align-items: center; margin-right: 10px;">
                    <img class="owner_tenant_img" [src]="ten.userimages.length > 0 ? ten.userimages[0].url : '../../assets/images/profile.png'">
                </div>
                <div class="col-sm-8 col-md-4" style="margin-left: 10px; margin-right: 10px;">
                    <p class="owner_tenant_name">{{ten.user.name}}</p><br>
                    <p class="owner_tenant_dtl">Aggreement start date : <span style="font-weight: 500;">{{ten.occupfrom}}</span></p><br>
                    <p class="owner_tenant_dtl">Aggreement end date : <span style="font-weight: 500;">{{ten.occupto}}</span></p><br>
                    <p class="owner_tenant_dtl">Deposit amount taken : <span style="font-weight: 500;">{{ten.deposite | currency:'INR':'symbol-narrow':'4.2-2'}}</span></p><br>
                    <p class="owner_tenant_dtl">Deposit amount to be returned : <span style="font-weight: 500;">{{ten.deposite | currency:'INR':'symbol-narrow':'4.2-2'}}</span></p><br>
                    <p class="owner_tenant_agg_link" (click)="openAggrement(ten.user_id)"><span style="color: #339af0"><fa-icon [icon]="faFileAlt"></fa-icon></span>  View Rent Aggreement</p>
                </div>
                
                <div class="col-md-4 doc_end" >
                    <p class="owner_tenant_name">Documents Submitted</p><br>
                    <div *ngFor="let doc of ten.userdocs">
                        <p *ngIf="doc.type != 'rent' && doc.status != 1" class="owner_tenant_doc_name" (click)="openDocs(doc.url)">
                            {{doc.type == 'adhar' ? 'Adhaar' : doc.type == 'pan' ? 'PAN' : doc.type == 'policeverification' ? 'Police Verification' : doc.type == 'employment' ? 'Employment Proof' : ''}}
                            <span [ngClass]="doc.status == 10 ? 'docVerified' : 'docPending'" >({{doc.status == 10 ? 'Verified' :'Pending'}})</span>
                        </p><br>
                    </div>
                </div>
            </div>
        </div>
        <div class="row sertype_detail_wrapper justify-content-between" *ngIf="selectedPropTenantData.length == 0" data-aos="fade-left" data-aos-duration="1000">
            <p class="noSerReq">There are no active tenants in your property! Your property is on top priority and we will make sure that the best tenants are found for your property</p>
        </div>
    </div>

    <!-- Owner Dashboard Audit Details -->
    <div *ngIf="ownerDbScreen == 'audits' && onboardingAuditLoading == true" style="height: 300px; display: flex; justify-content: center; align-items: center;" class="loaderWrapper">
        <img src="../../assets/images/loading.gif" class="faLoader" width="50" height="50" />
    </div>
    <div *ngIf="ownerDbScreen == 'audits' && onboardingAuditLoading == false">
        <select id="selectedProp" class="selected_prop" [ngModel]="selectedPropId" (ngModelChange)="changeProp($event)">
            <option *ngFor="let prop of ownerPropData" [ngValue]="prop.id">{{prop.name}}</option>
        </select>
        <h1 class="greeting" >Hi {{user.name}}! Let's look at the audits conducted in your property.</h1>
        <div *ngIf="totalAudits > 0">
            <div class="owner_audit_data" data-aos="fade-down" data-aos-duration="1000">
                <div class="audit_count">
                    <p><span>10</span><br><span>Passed Audits</span></p>
                </div>
                <div class="audit_count">
                    <p><span>5</span><br><span>Failed Audits</span></p>
                </div>
                <div class="audit_count">
                    <p><span>15</span><br><span>Total Audits</span></p>
                </div>
            </div>
                    
            <div class="aud_month_scroll_wrapper">
                <div class="conducted_audits" id="aud_month_list" data-aos="fade-right" data-aos-duration="1000">
                    <div *ngFor="let aud of conductedAudDtl; let first = first"  class="aud_month_wrapper" >
                        <div (click)="fetchAudit(aud.id)" class="aud_month" [ngClass]="selectedAuditMonthId == aud.id ? 'selected_audit_month' : '' ">
                            <p class="conducted_aud_month">{{aud.audMonth}}</p>
                            <p class="conducted_aud_month">{{aud.audYear}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="scroll_indicator_wrapper" *ngIf="totalAudits > 10">
                <img src="../../assets/images/left-arrow.svg" (click)="scrollLeft()" class="scroll_indicator">
                <img src="../../assets/images/right-arrow.svg" (click)="scrollRight()" class="scroll_indicator">
            </div>
            <!-- Individual audits details -->
            <div class="audit_detail" id="audit_detail" *ngIf="showAudits == 1" >
                <div class="audit_detail_navs" >
                    <p class="audit_detail_nav_item" [ngClass]="selectedAudSection == 'auddetails' ? 'selected_audit_nav_item' : ''" (click)="changeAuditSection('auddetails')">Audit Details</p>
                    <p class="audit_detail_nav_item" [ngClass]="selectedAudSection == 'healthstatus' ? 'selected_audit_nav_item' : ''" (click)="changeAuditSection('healthstatus')">Property Health</p>
                    <!-- <p class="audit_detail_nav_item" [ngClass]="selectedAudSection == 'audphotos' ? 'selected_audit_nav_item' : ''" (click)="changeAuditSection('audphotos')">Photos</p> -->
                </div>
                <!-- audit summry -->
                <div *ngIf="selectedAudSection == 'auddetails'">
                    <div *ngFor="let sum of selectedMonthSummary" class="audit_summary" [ngClass]="sum.status == 1? 'good' : 'bad'" data-aos="fade-right" >
                        <div style="width: 100%; display: flex; justify-content: space-between; align-items: center;">
                            <p class="audit_summary_category">
                                {{sum.category}}
                                <span class="audit_summary_status">({{sum.status == 0 ? "Needs Attention" : "Good"}})</span>
                            </p>
                            <fa-icon [icon]="sum.status == 1 ? faThumbsUp : faThumbsDown" class="fa-2x" [ngClass]="sum.status == 1 ? 'icon_good' : 'icon_poor'"></fa-icon>
                        </div>
                        <p class="audit_summary_comment">{{sum.newcomment}}</p>
                    </div>
                    <p class="audit_report_download" ><span style="color: #339af0"><fa-icon [icon]="faDownload" class="fa-lg" ></fa-icon></span> <a href="{{selectedAuditUrl}}"> Download Audit Report</a></p>
                </div>
                <!-- property health status -->
                <div *ngIf="selectedAudSection == 'healthstatus'">
                    <!-- overall -->
                    <div class="audit_summary" [ngClass]="phsoverall == 'Good' ? 'status_good' : phsoverall == 'Fair' ? 'status_fair' :'status_poor'" >
                        <div style="width: 100%; display: flex; justify-content: space-between; align-items: center;" >
                            <p class="audit_summary_category">Overall property health : <span>{{phsoverall}}</span></p>
                            <fa-icon 
                                [icon]="phsoverall == 'Good' ? faThumbsUp : faThumbsDown" 
                                class="fa-2x" [ngClass]="phsoverall == 'Good' ? 'icon_good' : phsoverall == 'Fair' ? 'icon_fair' : 'icon_poor' ">
                            </fa-icon>
                        </div>
                        <p class="audit_summary_comment">{{phsoverallremark}}</p>
                    </div>
                    <!-- cleanliness -->
                    <div class="audit_summary" [ngClass]="phsclean == 'Good' ? 'status_good' : phsclean == 'Fair' ? 'status_fair' :'status_poor'" >
                        <div style="width: 100%; display: flex; justify-content: space-between; align-items: center;">
                            <p class="audit_summary_category">Cleanliness and Hygiene : <span>{{phsclean}}</span></p>
                            <fa-icon 
                                [icon]="phsclean == 'Good' ? faThumbsUp : faThumbsDown" 
                                class="fa-2x" [ngClass]="phsclean == 'Good' ? 'icon_good' : phsclean == 'Fair' ? 'icon_fair' : 'icon_poor' ">
                            </fa-icon>
                        </div>
                        <p class="audit_summary_comment">{{phscleanremark}}</p>
                    </div>
                    <!-- furniture -->
                    <div class="audit_summary" [ngClass]="phsfurniture == 'Good' ? 'status_good' : phsfurniture == 'Fair' ? 'status_fair' :'status_poor'" >
                        <div style="width: 100%; display: flex; justify-content: space-between; align-items: center;">
                            <p class="audit_summary_category">Furniture and Appliances : <span>{{phsfurniture}}</span></p>
                            <fa-icon 
                                [icon]="phsfurniture == 'Good' ? faThumbsUp : faThumbsDown" 
                                class="fa-2x" [ngClass]="phsfurniture == 'Good' ? 'icon_good' : phsfurniture == 'Fair' ? 'icon_fair' : 'icon_poor' ">
                            </fa-icon>
                        </div>
                        <p class="audit_summary_comment">{{phsfurnitureremark}}</p>
                    </div>
                    <p class="audit_report_download" data-aos="fade-up" data-aos-duration="1000" ><span style="color: #339af0" ><fa-icon [icon]="faDownload" class="fa-lg"></fa-icon></span> <a href="{{selectedAuditUrl}}"> Download Audit Report</a></p>
                </div>
                <div *ngIf="selectedAudSection == 'audphotos'">
                    <div class="row justify-content-between" style="padding-left: 5%; padding-right: 5%; margin-top: 30px">
                        <div class="col-md-4 text-center" data-aos="fade-up" data-aos-duration="1000">
                            <img src="../../assets/images/audit_1.jpeg" class="audit_images">
                        </div>
                        <div class="col-md-4 text-center" data-aos="fade-up" data-aos-duration="1000">
                            <img src="../../assets/images/audit_2.jpeg" class="audit_images">
                        </div>
                        <div class="col-md-4 text-center" data-aos="fade-up" data-aos-duration="1000">
                            <img src="../../assets/images/audit_3.jpeg" class="audit_images">
                        </div>
                    </div>
                    <div class="row justify-content-between" style="padding-left: 5%; padding-right: 5%; margin-top: 30px">
                        <div class="col-md-4 text-center" data-aos="fade-up" data-aos-duration="1000">
                            <img src="../../assets/images/audit_4.jpeg" class="audit_images">
                        </div>
                        <div class="col-md-4 text-center" data-aos="fade-up" data-aos-duration="1000">
                            <img src="../../assets/images/audit_5.jpeg" class="audit_images">
                        </div>
                        <div class="col-md-4 text-center" data-aos="fade-up" data-aos-duration="1000">
                            <img src="../../assets/images/audit_6.jpeg" class="audit_images">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row sertype_detail_wrapper justify-content-between" *ngIf="totalAudits == 0" data-aos="fade-left" data-aos-duration="1000">
            <p class="noSerReq">No audits conducted till date!</p>
        </div>
    </div>

    <!-- Owner Dashboard Service Request Analysis -->
    <div *ngIf="ownerDbScreen == 'srequests' && onboardingSerLoading == true" style="height: 300px; display: flex; justify-content: center; align-items: center;" class="loaderWrapper">
        <img src="../../assets/images/loading.gif" class="faLoader" width="50" height="50" />
    </div>
    <div *ngIf="ownerDbScreen == 'srequests' && onboardingSerLoading == false">
        <select id="selectedProp" class="selected_prop" [ngModel]="selectedPropId" (ngModelChange)="changeProp($event)">
            <option *ngFor="let prop of ownerPropData" [ngValue]="prop.id">{{prop.name}}</option>
        </select>
        <h1 class="greeting">Hi {{user.name}}! Let's look at the service requests raised in your property.</h1>
        <div *ngIf="srTypeDetails.length > 0">
            <div class="total_sr_expense">
                <p style="font-weight: 500; font-size: 18px">Total Expense: {{srTotalPay |  currency:'INR':'symbol-narrow':'4.2-2'}}</p>
            </div>
            <div class="owner_service_data" data-aos="fade-down" data-aos-duration="1000">
                <div class="service_count">
                    <p><span>{{srOwnerPay}}</span><br><span>You have paid</span></p>
                </div>
                <div class="service_count">
                    <p><span>{{srTenantPay}}</span><br><span>Tenant Paid</span></p>
                </div>
                <div class="service_count">
                    <p><span>{{srYorPay}}</span><br><span>YOR Paid</span></p>
                </div>
            </div>
            <div class="row sertype_detail_wrapper justify-content-between">
                <div *ngFor="let ser of srTypeDetails ; let col=index" class="col-12 col-md-5 sertype_details" data-aos="fade-right" data-aos-duration="500" data-aos-offset="100" data-aos-easing="ease-in-sine" [ngStyle]="{'border-left-color': srColors[col], 'border-right-color': srColors[col]}">  
                    <div style="width: 100%; display: flex; justify-content: space-between; align-items: center;">
                        <p class="ser_type_name">{{ser.type}}</p>
                        <fa-icon [icon]="ser.typeid == 1 ? faKey : ser.typeid == 12 ? faFaucet : ser.typeid == 17 ? faCouch : ser.typeid == 47 ? faBroom : ser.typeid == 49 ? faPlug : ser.typeid == 51 ? faTools : faCogs" class="fa-2x" style="color: lightblue"></fa-icon>
                    </div>
                    <div style="width: 100%; display: flex; justify-content: space-between; align-items: center;">
                        <p class="ser_type_dtl">Total Requests :</p> 
                        <p class="ser_type_dtl" style="font-weight: 500;">{{ser.fcount}}</p>
                    </div>
                    <div style="width: 100%; display: flex; justify-content: space-between; align-items: center;">
                        <p class="ser_type_dtl">Total Amount Spent :</p>
                        <p class="ser_type_dtl" style="font-weight: 500;">{{ser.billamnt }}</p>
                    </div>
                    <div style="width: 100%; display: flex; justify-content: space-between; align-items: center;">
                        <p class="ser_type_dtl" style="font-weight: 600;">{{ser.percentage | number : '1.2-2'}} %</p>
                        <p style="font-size: 16px; cursor: pointer;" data-toggle="modal" data-target="#serviceReqModal" (click)="showRequests(ser.typeid , ser.type)">View Requests</p>
                    </div>
                </div>
                
            </div>
            <div class="col-md-6" style="margin: auto;" data-aos="fade-up" data-aos-duration="1000">
                <div style="display: block; margin-top:40px;">
                    <canvas baseChart
                            [data]="srChartData"
                            [labels]="srChartLabels"
                            [chartType]="srChartType"
                            [colors]="srChartColors"
                            (chartClick)="chartClicked($event)"></canvas>
                </div>
            </div>
            
            <!-- Service Request Modal -->
            <div class="modal fade" id="serviceReqModal" tabindex="-1" aria-labelledby="serviceReqModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                    <div class="modal-body">
                        <div style="width: 100%; display: flex; justify-content: end; position: absolute; top:-10px; right: -5px; cursor: pointer;">
                            <fa-icon [icon]="faTimes" class="fa-sm" data-dismiss="modal" ></fa-icon>
                        </div>
                        <div style="display: flex; justify-content: space-between;">
                            <h2 class="modal-title">{{selectedSerName}}</h2>
                            <fa-icon  [icon]="selectedSerType == 1 ? faKey : selectedSerType == 12 ? faFaucet : selectedSerType == 17 ? faCouch : selectedSerType == 47 ? faBroom : selectedSerType == 49 ? faPlug : selectedSerType == 51 ? faTools : faCogs" class="fa-2x" style="color: lightblue"></fa-icon>
                        </div>
                        <div 
                            *ngFor="let sr of sreqTypeData" class="sreqs" 
                            [ngStyle]=
                                "sr.status == 1 ? {'background-color' : '#FEF7EA' , 'border': '1px solid #F9E316'} : 
                                sr.status == 2 ? {'background-color' : '#E5EFFA' , 'border': '1px solid #339af0'} :  
                                {'background-color' : '#EBF7EE' , 'border': '1px solid #4BB543'}">
                            <div class="row justify-content-between">
                                <p class="col-12 col-md-4">
                                    <fa-icon [ngClass]="sr.status == 2 ? 'icon_glow' : ''" [icon]="faDotCircle" [ngStyle]="{'color' : sr.status == 1 ? '#F9E316' : sr.status == 2 ? '#339af0' : '#4BB543'}" ></fa-icon>
                                    #YOR_{{sr.id}}
                                </p>
                                <p style="text-align: end; "class="col-12 col-md-4">    
                                    {{sr.status == 1 ? 'Open' : sr.status == 2 ? 'In-Progress' : 'Closed'}} 
                                </p>
                            </div>
                            <br>
                            <p>{{sr.details}}</p>
                            <br>
                            <div class="row justify-content-between">
                                <div class="col-12 col-md-4">
                                    <p>Raised on: <span style="font-weight: 500;">{{sr.raised_on}}</span></p>
                                </div>
                                <div class="col-12 col-md-4" *ngIf="sr.status == 5" style="text-align: end;">
                                    <p>Closed on: <span style="font-weight: 500;">{{sr.closed_on}}</span></p>
                                </div>
                            </div>
                            <!-- <p data-toggle="modal" data-target="#serviceReqImgModal" (click)="showSerReqImg(sr.id)">View Images</p> -->
                        </div>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>
        <div class="row sertype_detail_wrapper justify-content-between" *ngIf="srTypeDetails.length == 0" data-aos="fade-left" data-aos-duration="1000">
            <p class="noSerReq">No service requests were raised till date!</p>
        </div>
    </div>

    <!-- Owner Dashboard Rent-O-Meter -->
    <div *ngIf="ownerDbScreen == 'rentmeter' && onboardingRentLoading == true" style="height: 300px; display: flex; justify-content: center; align-items: center;" class="loaderWrapper">
        <img src="../../assets/images/loading.gif" class="faLoader" width="50" height="50" />
    </div>
    <div *ngIf="ownerDbScreen == 'rentmeter' && onboardingRentLoading == false">
        <select id="selectedProp" class="selected_prop" [ngModel]="selectedPropId" (ngModelChange)="changeProp($event)">
            <option *ngFor="let prop of ownerPropData" [ngValue]="prop.id">{{prop.name}}</option>
        </select>
        <h1 class="greeting">Hi {{user.name}}! Let's look at the rental income from your property.</h1>
        <div *ngIf="checkRentMeter == 1">
            <div style="margin-top: 40px" class="row rent_meter_row justify-content-between">
                <div class='col-12 col-md-5 d-flex justify-content-center rentMeterWrapper' data-aos="fade-right" data-aos-duration="500">
                    <ngx-gauge [type]="rentMeterType"
                        [value]="rentMeterValue"
                        [label]="rentMeterLabel"
                        [thick]="50"
                        [cap]="round"
                        [size]="400"
                        [thresholds]="rentMeterThresholds"
                        append="%"
                    >
                    </ngx-gauge>
                </div>
                
                <div class="col-12 col-md-7 rent_ytd " data-aos="fade-left" data-aos-duration="1000">
                    <div class="rent_ytd_value_wrapper">
                        <p class="rent_ytd_value"><span>Property Rent (YTD): </span><span style="font-weight: 500;">{{rentData.totalownerrent  | currency:'INR':'symbol-narrow':'4.2-2'}}</span></p>
                    </div>
                    <div class="rent_ytd_value_wrapper">
                        <p class="rent_ytd_value"><span>Paid Rent (YTD): </span> <span style="font-weight: 500;">{{rentData.totalpaidrent  | currency:'INR':'symbol-narrow':'4.2-2'}}</span></p>
                    </div>
                </div>
            </div>
            <div class="row rent_details_dropdown">
                <select id="rent_detail_select" [ngModel]="selectedRentChart" (ngModelChange)="changeRentDetailChart($event)">
                    <option value="0" disabled >Filter By</option>
                    <option *ngFor="let t of chartTypes" [ngValue]="t.id">{{t.text}}</option>
                </select>
            </div>
            <div class ="col-10 justify-content-center rent_line_charts" *ngIf="dispRentDetails == 1" data-aos="fade-up" data-aos-duration="1000" data-aos-once="true">
                <canvas baseChart
                        [datasets]="rentLineChartData"
                        [labels]="rentLineChartLabels"
                        [options]="lineChartOptions"
                        [colors]="lineChartColors"
                        [legend]="rentLineChartLegend"
                        [chartType]="rentLineChartType">
                </canvas>
            </div>
            <div class ="col-10 justify-content-center rent_line_charts" *ngIf="dispRentDetails == 2" data-aos="fade-up" data-aos-duration="1000" data-aos-once="true">
                <canvas baseChart
                        [datasets]="rentLineChartData"
                        [labels]="rentLineChartLabels"
                        [options]="lineChartOptions"
                        [colors]="lineChartColors"
                        [legend]="rentLineChartLegend"
                        [chartType]="rentLineChartType">
                </canvas>
            </div>
            <div class="row justify-content-between" style="padding-left: 5%; padding-right: 5%;" *ngIf="dispRentDetails == 3  " >
                <div *ngFor="let rent of rentDetailsData"  class="rent_month_details col-12 col-md-5" data-aos="fade-up" data-aos-duration="800" data-aos-once="true" data-aos-delay="0" data-aos-offset="-25">
                        <div class="rent_month_dtl_head">
                            <p>{{rent.month_yr}}</p>
                            <p [ngStyle]="{'color': rent.percentage >= 80 ? 'lightseagreen' : rent.percentage >= 40 && rent.percentage < 80 ? 'deepskyblue' : 'coral' }">{{rent.percentage}}%</p>
                        </div>
                        <div class="rent_month_dtl_body">
                            <p style="font-weight: 400;">Committed Rent</p>
                            <p style="font-weight: 500;">{{rent.calculatedpropertypayamount | currency:'INR':'symbol-narrow':'4.2-2'}}</p>
                        </div>
                        <div class="rent_month_dtl_body">
                            <p style="font-weight: 400;">Paid Rent</p>
                            <p style="font-weight: 500;">{{rent.finalpropertypayamount | currency:'INR':'symbol-narrow':'4.2-2'}}</p>
                        </div> 
                        <hr>
                        <div class="rent_month_dtl_foot" *ngIf="rent.addition !== '0' ">
                            <div style="display: flex; justify-content: space-between;">
                                <p style="font-weight: 400;">Addition </p>
                                <p style="font-weight: 500;">{{rent.addition | currency:'INR':'symbol-narrow':'4.2-2'}}</p>
                            </div>
                            <br>
                            <p><span style="font-weight: 500;">Remark</span> : <spanRemark>{{rent.ad_remark}}</spanRemark></p>
                        </div>
                        <div class="rent_month_dtl_foot" *ngIf="rent.deduction !== '0'">
                            <div style="display: flex; justify-content: space-between;">
                                <p style="font-weight: 400;">Deduction </p>
                                <p style="font-weight: 500;">{{rent.deduction | currency:'INR':'symbol-narrow':'4.2-2'}}</p>
                            </div>
                            <br>
                            <p><span >Remark</span> : <span style="font-weight: 500;">{{rent.de_remark}}</span></p>
                        </div>
                        <div class="rent_month_dtl_foot" *ngIf="rent.addition == '0' ">
                            <p>No Additions</p>
                        </div>
                        <div class="rent_month_dtl_foot" *ngIf="rent.deduction == '0'">
                            <p>No Deductions</p>
                        </div>
                </div>
            </div>
        </div>
        <div class="row sertype_detail_wrapper justify-content-between" *ngIf="checkRentMeter == 0" data-aos="fade-left" data-aos-duration="1000">
            <p class="noSerReq">You have not recieved any rent from this property till date!</p>
        </div>
    </div>
   
</div>
